'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Subheading = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Subheading = require('./Subheading');

var _Subheading2 = _interopRequireDefault(_Subheading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.Subheading = _Subheading2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-subheading')(_Subheading2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-subheading/lib/cjs/index.js
 ** module id = 274
 ** module chunks = 1
 **/